/*eslint-disable*/
import React, { Component } from 'react'
import { Table, Header } from 'semantic-ui-react'
import { Field } from 'formik'
import SerialNumber from '../../apiInputComponent/serialNumber'
import JobcardSerialNo from '../../apiInputComponent/jobcardSerialNo'
export default class TyreDetailsInfo extends Component {

    state = {
        tyrNumber: [
            { "productInvId": "", "serialNo": "", "tyreRun": "", "tyrePositionId": "", "oldSerialNo": "" }
        ]
    }
    componentDidMount() {
        let info = this.props.getTyreInfo
        let tyresInfo = []
        info.map((object) => {
            tyresInfo.push(object.jb_tyres)
        })
        let filteredTyreInfo = [];
        tyresInfo = tyresInfo[0];
        let tyreRunValues = [];
        if (tyresInfo) {
            tyresInfo.map((o, i) => {
                filteredTyreInfo[i] = {};
                filteredTyreInfo[i]['jbTyreId'] = o.jbTyreId
                filteredTyreInfo[i]['oldSerialNo'] = o.oldSerialNo;
                filteredTyreInfo[i]['serialNo'] = o.serialNo;
                filteredTyreInfo[i]['tyreRun'] = o.tyreRun
                filteredTyreInfo[i]['tyrePositionId'] = o.tyrePositionId
                // filteredTyreInfo[i]['installationDate'] = o.installationDate
                filteredTyreInfo[i]['tyrePostionName'] = o.tyrePostionName
                tyreRunValues.push(o.tyreRun)
            })
        }
        this.setState({
            tyrNumber: filteredTyreInfo
        })
    }
    handleSerial = (e, data) => {
        if (data) {
            const { productInventoryId, serialNo } = data.value
            let initialpoint = this.state.tyrNumber
            initialpoint[data.dataId].productInvId = productInventoryId
            initialpoint[data.dataId].serialNo = serialNo
            this.setState({
                tyrNumber: [...initialpoint],
                isupdate: true
            }, () => this.props.getTyreUpdate(this.state.tyrNumber))
        }
    }
    render() {
        return (
            <React.Fragment>
                <Table hidden={this.props.hideDiv} unstackable size="small">
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan="4" size="small"><Header size="small" className="w3-white w3-text-blue labelName p-bold-500">Tyre Details</Header></Table.HeaderCell>
                        </Table.Row>
                        <Table.Row >
                            <Table.HeaderCell className="labelName p-bold-600">Tyre Position</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Old Serial Number</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600"> Serial Number</Table.HeaderCell>
                            <Table.HeaderCell className="labelName p-bold-600">Tyre Run (Kms)</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.state.tyrNumber.map((o, i) => (
                            <Table.Row>
                                <Table.Cell>{o.tyrePostionName}</Table.Cell>
                                <Table.Cell>{o.oldSerialNo}</Table.Cell>
                                <Table.Cell>
                                    {this.props.fromApproval === '1' || this.props.onlyDisplay ? o.serialNo : <Field component={JobcardSerialNo} disabled className="disabledField p-placeholder" placeholder={o.serialNo} dataId={i} TyreId="1" isAvailable="1" onChange={this.handleSerial} />}
                                </Table.Cell>
                                <Table.Cell>{o.tyreRun}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>

            </React.Fragment>
        )
    }
}
